import type { Resource } from '../../';
export const country_countries_IL: Resource = {"default":"Israel"};
